import React, { useRef, useState } from "react"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"

import { CarouselNavigation, RichText, TextLink } from "components"

import Post from "./_Post"
import PseudoBackground from "./_PseudoBackground"

function TalkingShopFeed({ content, feeds, type }) {
  // find the feed input that matches the set content
  let matchedFeed = {}
  if (type?.slug) {
    feeds?.forEach(feed => {
      if (feed.category === type?.slug) {
        matchedFeed = feed
      }
    })
  }

  // setup slider variables
  const sliderRef = useRef()
  const [activeSlide, setActiveSlide] = useState(0)

  const CAROUSEL_SETTINGS = {
    className: "contentFeed",
    dots: false,
    arrows: false,
    draggable: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    rows: 1,
    initialSlide: 0,
    speed: 500,
    infinite: true,
    adaptiveHeight: false,
    variableWidth: false,
    accessibility: false,
    onInit: () => {
      let slickList = document.getElementsByClassName("slick-list")
      for (var i = 0; i < slickList.length; i++) {
        let slides = slickList[i].firstChild.childNodes
        for (var c = 0; c < slides.length; c++) {
          let anchor = slides[c].firstChild.firstChild.firstChild
          if (slides[c].getAttribute("data-index") === "0") {
            slides[c].setAttribute("tabindex", 0)
            anchor.setAttribute("tabindex", 0)
          } else {
            slides[c].setAttribute("tabindex", -1)
            anchor.setAttribute("tabindex", -1)
          }
        }
      }
    },
    beforeChange: (current, next) => setActiveSlide(next),
    afterChange: current => {
      let slickList = document.getElementsByClassName("slick-list")
      for (var i = 0; i < slickList.length; i++) {
        let slides = slickList[i].firstChild.childNodes
        for (var c = 0; c < slides.length; c++) {
          let anchor = slides[c].firstChild.firstChild.firstChild
          if (slides[c].getAttribute("data-index") === current.toString()) {
            slides[c].setAttribute("tabindex", 0)
            anchor.setAttribute("tabindex", 0)
          } else {
            slides[c].setAttribute("tabindex", -1)
            anchor.setAttribute("tabindex", -1)
          }
        }
      }
    },
  }

  if (matchedFeed) {
    return (
      <section data-slice="TalkingShopFeed">
        {content && (
          <div className="relative pt-10 pb-5 md:pt-14 md:pb-14 wrapper default-grid">
            <div className="col-span-full md:col-span-10 md:col-start-2">
              <RichText
                className="contentFeedContent"
                content={content}
                size="small"
              />
            </div>
          </div>
        )}
        <div className="relative wrapper">
          <PseudoBackground />
          <div className="relative pb-10 default-grid md:pb-14 gap-y-8 md:gap-y-14">
            <div className="row-span-1 row-start-1 -mx-3 col-span-full lg:col-span-6 lg:col-start-4 sm:-mx-fluidMargin md:-mx-4 lg:-mx-10 xl:-mx-14">
              <Slider {...CAROUSEL_SETTINGS} ref={sliderRef}>
                {matchedFeed?.items?.map(({ category, slug, ...rest }, i) => (
                  <Post
                    active={activeSlide === i}
                    activeSlide={activeSlide}
                    category={type}
                    href={`/news/${
                      category?.slug === "/" ? "" : category?.slug + "/"
                    }${slug}/`}
                    index={i}
                    sliderRef={sliderRef}
                    {...rest}
                    key={`contentFeedItem-${i}`}
                  />
                ))}
              </Slider>
            </div>
            <div className="flex justify-center row-span-1 row-start-2 md:col-span-4 col-span-full md:col-start-5">
              <CarouselNavigation
                prevOnClick={() => {
                  if (sliderRef?.current) {
                    sliderRef.current.slickGoTo(activeSlide - 1)
                  }
                }}
                nextOnClick={() => {
                  if (sliderRef?.current) {
                    sliderRef.current.slickGoTo(activeSlide + 1)
                  }
                }}
              />
            </div>
            <div className="flex self-center row-span-1 row-start-3 md:justify-end md:row-start-2 col-span-full md:col-span-4 md:col-start-9">
              <p className="w-full text-center md:text-right body">
                <TextLink
                  label={"See more " + type?.name?.toLowerCase()}
                  href={`/news/${type?.slug === "/" ? "" : type?.slug}`}
                />
              </p>
            </div>
          </div>
        </div>
      </section>
    )
  } else {
    return null
  }
}

export default TalkingShopFeed
